import { sameTenantIdentity, type TenantIdentity } from './identity'

export interface ReconcileInput {
  /** O que o bootstrap pintou neste boot — `null` no primeiro boot absoluto. */
  applied: TenantIdentity | null
  /** O que está gravado no dispositivo para este host. */
  stored: TenantIdentity | null
  /** O que a resposta confirmada da sessão corrente trouxe. */
  incoming: TenantIdentity | null
}

export interface ReconcileDecision {
  /** Gravar o retrato novo para o próximo boot. */
  write: boolean
  /** Pintar agora, na sessão corrente. */
  apply: boolean
}

/**
 * Decide o que fazer quando a resposta confirmada chega (design D4 e D5).
 *
 * Identidade divergente é gravada e **não** aplicada: repintar aos oito
 * segundos é o mesmo flash que a change remove, com o participante já lendo a
 * tela. A correção entra no próximo boot.
 *
 * Exceção única: primeiro boot absoluto, sem nada pintado nem gravado — não há
 * identidade anterior a preservar, e aplicar na hora é melhor que seguir com a
 * marca da plataforma.
 */
export function reconcileTenantIdentity({
  applied,
  stored,
  incoming
}: ReconcileInput): ReconcileDecision {
  if (!incoming) return { write: false, apply: false }

  const primeiroBootAbsoluto = !applied && !stored

  return {
    write: !sameTenantIdentity(stored, incoming),
    apply: primeiroBootAbsoluto
  }
}
